// extracted by mini-css-extract-plugin
export default {"base":"vp_p9K5S","label":"vp_UtCTG","rankLow":"vp_j8q90","rankMid":"vp_BuDWg","rankHigh":"vp_Jysxb"};